import React, { useEffect, useState } from 'react'
import SuperSearchMultipleServer from '../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer'
import SuperSearchList from '../shared/SuperSearch/SuperSearchList'
import AddNewPat from '../shared/AddNewPatient/AddNewPat';
import { enumUtil } from '../../utils/Enum';
import isNull from '../../utils/NullChecking';
import NotificationHandler from '../../utils/NotificationHandler';
import { getPatientInsurances } from './AddNewAppointmentSubComponents/services/AppointmentService';
import { useSelector } from 'react-redux';
import DropdownValueHandler from '../shared/SuperSearch/DropdownValueHandler';
import Loader from '../shared/Loader/Loader';

const GroupAppointmentPatientSection = (props) => {
    const { mainAppointmentModal, setMainAppointmentModal, saveAppointmentModal,
        setSaveAppointmentModal, getAvailableSlotsByParam, handleAppointmentTypeDD,
        setProvID, setLocID, setAllPatientDetails, allPatientDetails, AppointmentID, getProceduresByAppointmentType } = { ...props }
    const API_URL_Patient = enumUtil.controller.PATIENT
    const [showParticipant, setShowParticipant] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [reloadSuperSearchPatient, setreloadSuperSearchPatient] = useState(false)
    const [patientValue, setPateintValue] = useState([])
    const dropDownReducer = useSelector((state) => { return state.GeneralDropDownsReducer });
    const appointmentStatusList = dropDownReducer.AppointmentStatus;
    const appointmentStatusListTeleHealth = dropDownReducer.AppointmentStatus.filter(
        item => item.value === 11 || item.value === 12
    );
    const [is, setIs] = useState(true);

    const [showPatientDetails, setPateintDetails] = useState([0, "0", null].includes(AppointmentID) ? false : true)
    // add new patient 
    const [isOpenPatient, setIsOpenPatient] = useState(false)
    const [appointmentStatusAll, setAppointmentStatusAll] = useState('')
    const currentDate = dropDownReducer?.CurrentPracticeDate;
    const handleOpenPatient = () => {
        setIsOpenPatient(true)
    }
    const handleClosePatient = () => {
        setIsOpenPatient(false)
    }
    let AddPAtPopup = ''
    if (isOpenPatient) {
        AddPAtPopup = <AddNewPat isOpenPatient={isOpenPatient} onClose={handleClosePatient} />
    }
    // patient selection 
    const [searchParam, setSearchParam] = useState({ PatientIDs: '' });
    const handleRemovePateint = (id) => {
        let data = allPatientDetails.filter(item => String(item.PatientID) !== String(id))
        const patientList = data.map((item) => ({
            value: item.value,
            display: item.display,
        }));
        setPateintValue(patientList);
        setAllPatientDetails(data);
        setSearchParam(prev => {
            const updatedIds = (prev.PatientIDs || "")
                .split(",")
                .map(x => x.trim())
                .filter(x => x && x !== String(id))
                .join(",");

            return {
                ...prev,
                PatientIDs: updatedIds
            };
        });
        const updatedPatientIDs = (mainAppointmentModal.PatientID || "")
            .split(",")
            .map(x => x.trim())
            .filter(x => x && x !== String(id))
            .join(",");
        // Update saveAppointmentModal
        setSaveAppointmentModal(prev => ({
            ...prev,
            PatientID: updatedPatientIDs
        }));
        setreloadSuperSearchPatient(!reloadSuperSearchPatient)

    }
    useEffect(() => {
        const selectedIds = (searchParam.PatientIDs || "")
            .split(",")
            .map(x => x.trim())
            .filter(Boolean);

        setAllPatientDetails(prev =>
            prev.filter(patient =>
                selectedIds.includes(String(patient.PatientID))
            )
        );
        const lastID = selectedIds[selectedIds.length - 1];
        if (lastID) {
            GetPatientDetails(lastID);
        }
        const commaSeparatedIds = selectedIds.join(',');
        setSaveAppointmentModal(prev => ({
            ...prev,
            PatientID: commaSeparatedIds
        }));

    }, [searchParam?.PatientIDs]);
    const GetPatientDetails = async (id) => {
        const patientExists = allPatientDetails.some(
            x => String(x.PatientID) === String(id)
        );
        if (patientExists) {
            return;
        }
        try {
            setIsLoading(true)
            const response = await getPatientInsurances(id);
            setIsLoading(false)
            let modal = { ...mainAppointmentModal }
            let saveModal = { ...saveAppointmentModal }
            modal['PatientID'] = searchParam.PatientIDs
            saveModal['PatientID'] = searchParam.PatientIDs
            let data = [...allPatientDetails]
            if (isNull(mainAppointmentModal.PatientID)) {
                getAvailableSlotsByParam(response.ProviderID, response.LocationID, mainAppointmentModal.AppointmentDate)
                modal['ProviderID'] = response.Providers
                modal['LocationID'] = response.LocationName
                saveModal['ProviderID'] = response.ProviderID + ""
                saveModal['LocationID'] = response.LocationID + ""
                setProvID(response.ProviderID + "")
                setLocID(response.LocationID + "")

                let appointmentTypeDD = handleAppointmentTypeDD(response.ProviderID + "")
                if (appointmentTypeDD.length === 1) {
                    modal['AppointmentTypeID'] = appointmentTypeDD[0].display
                    saveModal['AppointmentTypeID'] = appointmentTypeDD[0].value + ""
                    modal["AppointmentType"] = appointmentTypeDD[0]?.display;
                    const duration = appointmentTypeDD[0]?.Duration;
                    getProceduresByAppointmentType(appointmentTypeDD[0].value)
                    if (!isNull(duration)) {
                        modal["DurationID"] = duration;
                        saveModal["DurationID"] = duration;
                    }
                } else {
                    modal['AppointmentTypeID'] = ''
                    saveModal['AppointmentTypeID'] = ''
                    modal["AppointmentType"] = ''
                }
            } else {
            }
            response['AppointmentStatus'] = '1'
            response['AppointmentStatusDisplay'] = 'Scheduled'
            response['PatientAppointmentID'] = ''
            setMainAppointmentModal(modal)
            setSaveAppointmentModal(saveModal)
            data.push(response);
            setAllPatientDetails(data)
            return response
        } catch (error) {
            return null
        }
    };
    useEffect(() => {
        if (mainAppointmentModal?.PatientList?.length > 0) {
            let patientData = [...(mainAppointmentModal?.PatientList || [])];
            patientData = patientData.map((item) => {
                return {
                    ...item,
                    AppointmentStatusDisplay: DropdownValueHandler(appointmentStatusList, item.AppointmentStatus)
                };
            });
            setAllPatientDetails(patientData);
            const patientList = mainAppointmentModal.PatientList.map((item) => ({
                value: item.value,
                display: item.display,
            }));
            const patientIDs = mainAppointmentModal.PatientList
                .map((item) => item.value)
                .join(",");
            setPateintValue(patientList);
            // setSearchParam((prev) => ({
            //     ...prev,
            //     PatientIDs: patientIDs,
            // }));
            let modal = { ...mainAppointmentModal }
            let saveModal = { ...saveAppointmentModal }
            modal['PatientID'] = patientIDs
            saveModal['PatientID'] = patientIDs
            setMainAppointmentModal(modal)
            setSaveAppointmentModal(saveModal)
        }
        setreloadSuperSearchPatient((prev) => !prev);
    }, [mainAppointmentModal?.PatientList]);
    const handleOnChange = (e, index) => {
        setIs(false)
        let { name, value } = e.target
        let data = [...allPatientDetails]
        data[index]['AppointmentStatusDisplay'] = value
        setAllPatientDetails(data)
    }
    const handleChangeAppointmentStatusAll = (e) => {
        setIs(false)
        let { name, value } = e.target
        setAppointmentStatusAll(value)
    }
    const handleAppointmentSelectedData = (selectedData, name, type, index) => {
        setIs(true)
        if (!isNull(selectedData) && type === 'client') {
            if (name === 'AppointmentStatusAll') {
                setAppointmentStatusAll(selectedData.display)
                let data = [...allPatientDetails]
                data = data.map((item) => ({
                    ...item,
                    AppointmentStatus: selectedData.value,
                    AppointmentStatusDisplay: selectedData.display
                }));
                setAllPatientDetails(data)
            } else {
                let data = [...allPatientDetails]
                data[index]['AppointmentStatus'] = selectedData.value
                data[index]['AppointmentStatusDisplay'] = selectedData.display
                setAllPatientDetails(data)
            }
        } else {
            if (name === 'AppointmentStatusAll') {
                setAppointmentStatusAll('')
            }
            let data = [...allPatientDetails]
            data[index]['AppointmentStatus'] = ''
            setAllPatientDetails(data)
        }
    }

    const handleEditStatus = () => {
        if (mainAppointmentModal.AppointmentDate > currentDate) {
            return
        }
        setEditStatus(true)
    }

    const handleCloseEditStatus = () => {
        setEditStatus(false)
    }

    return (
        <>
            {AddPAtPopup}
            {isLoading ? <Loader /> : null}
            {!showPatientDetails ?
                <div className="agency-pat-search d-flex gap-1 w-100 ar-pat-search-group-apt">
                    <div className="input w-100">
                        <div className='input-group'>
                            <SuperSearchMultipleServer
                                key={reloadSuperSearchPatient}
                                id="PatientIDs"
                                name="PatientIDs"
                                SuperSearchView="DetailedView"
                                DesignView="GroupAppointmentMultiline"
                                DetailedView="Patient"
                                initialSelectedOptionsInstant={patientValue}
                                // initialSelectedOptionsInstant={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                tableName={enumUtil.enumAPITableName.Patient}
                                controller={API_URL_Patient}
                                ApiLink={"/InstantSearchWithDetails"}
                                method='post'
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                    </div>

                    <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn flex-shrink-0" onClick={handleOpenPatient}>
                        <i className="icon-Group-5719"></i>
                    </button>
                </div>
                : null}
            {![0, "0", null].includes(AppointmentID) && (
                <div className="client_detail gap-2 d-flex position-relative group-appointment">
                    {showPatientDetails ? <div className='search'>
                        <i className='bi bi-search' onClick={() => setPateintDetails(!showPatientDetails)}></i>
                    </div> :
                        <div className='search'>
                            <i className='icon-close fs-7' onClick={() => setPateintDetails(!showPatientDetails)}></i>
                        </div>}

                    {allPatientDetails.length > 0 ?
                        <div className="d-flex flex-column gap-1 w-100">

                            <div className="d-flex align-items-center gap-6">
                                <i className='icon-group-pateint fs-13'></i>
                                <p className='heading'>Participants {allPatientDetails.length > 0 ? `(${allPatientDetails.length})` : ''}</p>
                            </div>
                            <div className="">
                                <p className="text">
                                    {allPatientDetails
                                        ?.slice(0, 7)
                                        .map(patient => patient.PatientName)
                                        .join(" | ")}

                                    {allPatientDetails?.length > 7 && ` | +${allPatientDetails.length - 7} more`}
                                </p>
                            </div>


                            <div className={`d-flex align-items-center justify-content-between za_br_light ${showParticipant ? 'br-bottom-1 pb-1-5' : ''} `}>
                                <p className="heading za-blue-clr fs-11 user-select-none cursor-pointer lh-18 text-decoration-underline" onClick={() => setShowParticipant(!showParticipant)}>{showParticipant ? 'Hide All' : 'View All'}
                                </p>
                                {showParticipant && (
                                    editStatus ? (
                                        <div className="d-flex gap-10 align-items-center">
                                            {![0, "0", null].includes(AppointmentID) && (
                                                <div className="input h-20 w-146px">
                                                    <SuperSearchList
                                                        type="client"
                                                        id="AppointmentStatusAll"
                                                        name="AppointmentStatusAll"
                                                        searchValue={appointmentStatusAll}
                                                        data={
                                                            mainAppointmentModal?.AppointmentMode === "Telehealth"
                                                                ? appointmentStatusListTeleHealth
                                                                : appointmentStatusList
                                                        }
                                                        onChange={handleChangeAppointmentStatusAll}
                                                        getSelectedData={handleAppointmentSelectedData}
                                                        icon="Simple"
                                                        is={is}
                                                        sup_btn="sup_btn"
                                                        sup_inp="superSearchVisitInp"
                                                    />
                                                </div>
                                            )}

                                            <div className="app_tooltip left">
                                                <i
                                                    className="icon-x-cros fs-15 dark-clr fw-900"
                                                    onClick={handleCloseEditStatus}
                                                ></i>
                                                <p className="tool_tip xsm_text text-light">
                                                    Return to View Mode
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <i
                                            className={`icon-Icon-material-edit fs-11 ar-light-color ${mainAppointmentModal.AppointmentDate > currentDate ? 'disabled' : ''}`}
                                            onClick={handleEditStatus}
                                        ></i>
                                    )
                                )}

                            </div>

                            {showParticipant ? <div className="d-flex flex-column gap-5">
                                {allPatientDetails.map((item, index) => {
                                    return (
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className='text fs-11 ar-bullet ps-1-5'><span className='font-m fs-12'>{item.PatientName}</span> {item.DOB ? item.DOB : ''} ({item.Age}) {item.Gender}</p>
                                            {editStatus ?
                                                <>
                                                    {![0, "0", null].includes(AppointmentID) ?
                                                        <div className="d-flex gap-10 align-items-center">
                                                            <div className="input h-20 w-146px">
                                                                <SuperSearchList
                                                                    type="client"
                                                                    id='AppointmentStatusDisplay'
                                                                    name='AppointmentStatusDisplay'
                                                                    searchValue={allPatientDetails[index]?.AppointmentStatusDisplay}
                                                                    data={mainAppointmentModal?.AppointmentMode === 'Telehealth' ? appointmentStatusListTeleHealth : appointmentStatusList}
                                                                    onChange={(e) => handleOnChange(e, index)}
                                                                    getSelectedData={(selectedData, name, type) => handleAppointmentSelectedData(selectedData, name, type, index)}
                                                                    icon={'Simple'}
                                                                    is={is}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                />
                                                            </div>
                                                            {/* <i className='icon-x-cros fs-15 dark-clr fw-900' onClick={() => handleRemovePateint(item.PatientID)} ></i> */}
                                                        </div>
                                                        : null}
                                                </>
                                                :
                                                <div className="">
                                                    <p className={`pill ${item.AppointmentStatusDisplay.replace(/\s/g, '-')}`}>{item.AppointmentStatusDisplay}</p>
                                                </div>
                                            }
                                        </div>
                                    )
                                })}
                            </div> : <></>}

                        </div>
                        : null}
                </div>
            )}
        </>
    )
}

export default GroupAppointmentPatientSection